/* @flow */

import React, { Component } from 'react';
import { Modal, Button } from 'semantic-ui-react';
import ReactCrop from 'react-image-crop';

export type CropConfig = {
  width?: number,
  height?: number,
  x?: number,
  y?: number,
  aspect?: number,
};

type Props = {
  open: boolean,
  image: string,
  fullWidth?: boolean,
  fullHeight?: boolean,
  config?: CropConfig,
  onComplete: (crop: CropConfig) => void,
  onClose: () => void,
};

type State = {
  crop?: CropConfig,
};

// TODO: display loader while loading image (see onImageLoaded props from ReactCrop)
class ImageCrop extends Component {
  props: Props;
  state: State;

  constructor(props: Props) {
    super(props);

    this.state = {
      crop: props.config,
    };
  }

  componentWillReceiveProps(nextProps: Props) {
    if (nextProps.config !== this.props.config) {
      this.setState({
        crop: nextProps.config,
      });
    }
  }

  onCropComplete = (crop: CropConfig) =>
    this.setState({
      crop: {
        ...crop,
        aspect: crop.aspect || undefined,
      },
    });

  onConfirm = () => {
    const { crop } = this.state;
    if (crop) {
      this.props.onComplete(crop);
    }
  };

  render() {
    const { open, image, fullWidth, fullHeight, onClose } = this.props;
    const { crop } = this.state;

    let minWidth, minHeight;
    if (fullWidth) {
      minWidth = 100;
    } else if (fullHeight) {
      minHeight = 100;
    }

    return (
      <Modal
        closeIcon
        open={open}
        onClose={onClose}
        closeOnRootNodeClick={false}
      >
        <Modal.Header>Redimensionnement de l'image</Modal.Header>
        <Modal.Content image>
          <ReactCrop
            src={image}
            crop={crop}
            crossorigin="Anonymous"
            minWidth={minWidth}
            minHeight={minHeight}
            onComplete={this.onCropComplete}
          />
        </Modal.Content>
        <Modal.Actions>
          <Button
            type="button"
            onClick={this.onConfirm}
            positive
            icon="checkmark"
            labelPosition="right"
            content="Valider"
          />
        </Modal.Actions>
      </Modal>
    );
  }
}

export default ImageCrop;



// WEBPACK FOOTER //
// ./src/shared/components/ImageCrop.js